import { disableNotifications } from "./pwa";
import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("aa_token")) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("aa_token"); setUser(false); });
  }, []);

  const signIn = (data) => { localStorage.setItem("aa_token", data.token); setUser(data.user); return data.user; };
  const signOut = async () => { await disableNotifications().catch(() => {}); localStorage.removeItem("aa_token"); setUser(false); };
  const refresh = () => api.get("/auth/me").then((r) => setUser(r.data));

  return <AuthCtx.Provider value={{ user, setUser, signIn, signOut, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
